"use client";

import * as React from "react";
import { Flame, Scale, Wheat, Info, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger, DialogClose } from "@/components/ui/dialog";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const cuts = [{
  id: "brisket",
  name: "דנבר",
  shortDesc: "\n",
  fullDesc: "נתח דנבר פרימיום שלם, נתח בעל טעמי בקר עזים ועמוקים עם שיוש שומן פנימי מרהיב מעושן בשיטת LOW&SLOW ארוך עד לרכות מדהימה.\nתיבול: מלח ים אטלנטי, פלפל שחור גרוס, פפריקה.",
  price: "₪85",
  weight: "1.2 קילו",
  spices: ["פלפל שחור גרוס", "מלח ים אטלנטי", "שום גבישי"],
  nutrition: {
    protein: "28g",
    fat: "18g",
    cal: "320"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/smoked_brisket_macro.png"
}, {
  id: "asado",
  name: "אסאדו\xA0",
  shortDesc: "\n",
  fullDesc: "נתח הצלעות המפורסם של הבקר בעל שכבות שומן וטעם עמוק ועשיר\nתיבול: חרדל דיז'ון, שום, טימין, רוזמרין, טריאקי",
  price: "₪92",
  weight: "כ1.2 קילו",
  spices: ["פפריקה מעושנת", "כמון", "סוכר חום", "צ'ילי"],
  nutrition: {
    protein: "24g",
    fat: "32g",
    cal: "450"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/asado_ribs_close.png"
}, {
  id: "picanha",
  name: "פיקאניה\xA0",
  shortDesc: "\n",
  fullDesc: "נתח ברזילאי קלאסי עם שכבת השומן העסיסית מעושן בתיבול דרום אמריקאי עשיר\nתיבול: פפריקנה עושנת, אורגנו, צ'ילי גרוס, גרגירי כוסברה",
  price: "\n",
  weight: "כ1.2 קילו",
  spices: ["מלח ים", "רוזמרין", "שמן זית"],
  nutrition: {
    protein: "32g",
    fat: "14g",
    cal: "280"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/picanha_sliced.png"
}, {
  id: "pulled-beef",
  name: "סינטה",
  shortDesc: "\n",
  fullDesc: "הנתח האצילי והבשרני של גב הבקר, המשלב מרקם מוצק עם טעם בשרני עמוק עטוף בשכבת שומן חיצונית השומרת על עסיסיותו\nתיבול: פפריקה, אורגנו, כמון, פלפל שחור גס, חרדל צהוב",
  price: "₪78",
  weight: "כ1.2 קילו",
  spices: ["בצל מיובש", "שום", "רוטב ברביקיו", "חומץ תפוחים"],
  nutrition: {
    protein: "26g",
    fat: "12g",
    cal: "250"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/pulled_beef_shoulder.png"
}, {
  id: "pulled-beef-dup",
  name: "אונטריב",
  shortDesc: "\n",
  fullDesc: "נתח עשיר בטעם עם שכבצ שומן חיצונית המגנה עליו מעושן בשיטת LOW&SLOW עד לרכות מדהימה\nתיבול: מלח מעושן, פלפל שחור גרוס, פפרחקה מתוקה, חרדל דיז'ון, סוכר חום",
  price: "₪78",
  weight: "כ1.2 קילו",
  spices: ["בצל מיובש", "שום", "רוטב ברביקיו", "חומץ תפוחים"],
  nutrition: {
    protein: "26g",
    fat: "12g",
    cal: "250"
  },
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/pulled_beef_shoulder.png"
}];
export default function CutsMenu() {
  return <section id="תפריט-הנתחים" className="dark bg-background text-foreground py-16 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center space-y-4">
          <h2 className="text-4xl md:text-5xl font-black tracking-tight text-primary uppercase">
            תפריט הנתחים
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            הבשרים שלנו נבחרים בקפידה, מתובלים בתערובות תבלינים ייחודיות
            ומעושנים בשיטות מסורתיות (Low & Slow) לקבלת טעם ומרקם מושלמים.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {cuts.map((cut, i) => <div key={cut.id} data-index={i} className="h-full">
              <Dialog>
                <DialogTrigger asChild>
                  <Button variant="ghost" className="group relative h-full w-full p-0 whitespace-normal block text-right hover:bg-transparent hover:text-foreground rounded-xl">
                    <Card className="h-full overflow-hidden border-border/40 bg-card/50 hover:bg-card/80 transition-all duration-300 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/10 flex flex-col">
                      {}
                      <div className="relative aspect-[4/3] overflow-hidden w-full bg-muted">
                        
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-60" />

                        {}
                        
                      </div>

                      <CardHeader className="pb-2 pt-4 relative z-10">
                        <CardTitle className="text-2xl font-black text-primary tracking-wide">
                          {cut.name}
                        </CardTitle>
                      </CardHeader>

                      <CardContent className="flex-grow relative z-10">
                        <CardDescription className="text-base text-muted-foreground line-clamp-2">
                          {cut.shortDesc}
                        </CardDescription>
                        <p className="mt-2 text-sm text-muted-foreground/80 line-clamp-3">
                          {cut.fullDesc}
                        </p>
                      </CardContent>

                      <CardFooter className="pt-2 pb-4 relative z-10">
                        <span className="text-xs font-medium text-accent-foreground/60 uppercase tracking-wider flex items-center gap-1 group-hover:text-primary transition-colors">
                          <Flame className="w-3 h-3" />
                          הזמינו עכשיו
                        </span>
                      </CardFooter>
                    </Card>
                  </Button>
                </DialogTrigger>

                <DialogContent className="sm:max-w-3xl p-0 gap-0 overflow-hidden bg-card border-border">
                  <div className="grid md:grid-cols-2 h-full">
                    {}
                    <div className="relative h-64 md:h-full w-full bg-muted">
                      <img src={cut.image} alt={cut.name} className="absolute inset-0 h-full w-full object-cover" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent md:bg-gradient-to-r md:from-transparent md:via-black/20 md:to-black/90" />

                      {}
                      <div className="absolute top-4 left-4 md:top-6 md:left-6 z-20">
                        
                      </div>
                    </div>

                    {}
                    <div className="p-6 md:p-8 flex flex-col h-full overflow-y-auto max-h-[80vh] md:max-h-none bg-card">
                      <DialogHeader className="mb-6 text-right">
                        <DialogTitle className="text-3xl md:text-4xl font-black text-primary mb-2">
                          {cut.name}
                        </DialogTitle>
                        <DialogDescription className="text-lg text-foreground/90 leading-relaxed">
                          {cut.fullDesc}
                        </DialogDescription>
                      </DialogHeader>

                      <div className="space-y-6 flex-grow">
                        {}
                        <div className="space-y-3">
                          
                          
                        </div>

                        {}
                        <div className="space-y-3">
                          
                          
                          <div className="mt-2 flex items-center justify-between bg-secondary/20 p-3 rounded border border-primary/20">
                            <span className="text-sm font-medium">
                              משקל מנה ממוצע:
                            </span>
                            <span className="font-bold text-primary">
                              {cut.weight}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="mt-8 pt-6 border-t border-border flex gap-3">
                        <Button className="w-full font-bold text-base" size="lg">
                          <Flame className="w-4 h-4 mr-2 fill-current" />
                          הוסף להזמנה
                        </Button>
                        <DialogClose asChild>
                          <Button variant="outline" size="lg" className="px-4">
                            סגור
                          </Button>
                        </DialogClose>
                      </div>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <Link to="#">
            
          </Link>
        </div>
      </div>
    </section>;
}